/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";

export default baustein.register("profile-page", {
    init: function() {
        this.profileId = this.options.profileId;
    },

    setupEvents: function(add) {
        add("userFollow", this.onUserFollow);
        add("userUnfollow", this.onUserUnfollow);
    },

    onUserUnfollow: function(event) {
        this.findComponent("profile-header-counters").updateFollowCounter(event, this.profileId);
    },

    onUserFollow: function(event) {
        this.findComponent("profile-header-counters").updateFollowCounter(event, this.profileId);
    }
});

